/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Text } from '@mantine/core';
import classes from './TableProducersProjects.module.css';
import { uuid } from '@utils/functions';
import { Tooltip } from '@components/atoms/Tooltip';
import { useTranslation } from 'react-i18next';
import { NOT_APPLICABLE } from '@config/constants/common';
import clsx from 'clsx';

export const TableProducersProjects = (props: {
	rows: any;
}) => {
	const { t } = useTranslation();

	return (
		<Box className={classes.table}>
			<Box className={classes.header}>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.name')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text
						className={clsx(
							classes.title,
							classes.titleEnd
						)}
					>
						{t('global.measurabilities')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text
						className={clsx(
							classes.title,
							classes.titleEnd
						)}
					>
						{t('global.additionalities')}
					</Text>
				</Box>
			</Box>
			{props.rows &&
				props.rows.length !== 0 &&
				props.rows.map((item: any) => (
					<Box key={uuid()} className={classes.row}>
						<Tooltip
							isActive={
								item.name && item.name.length > 27
							}
							label={item && item.name ? item.name : ''}
						>
							<Box className={classes.cell}>
								<Text className={classes.value}>
									{item.name}
								</Text>
							</Box>
						</Tooltip>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Text className={classes.value}>
								{item.measurabilities &&
								Array.isArray(item.measurabilities)
									? item.measurabilities.length
									: 0}
							</Text>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Text className={classes.value}>
								{item.additionalities &&
								Array.isArray(item.additionalities)
									? item.additionalities.length
									: 0}
							</Text>
						</Box>
					</Box>
				))}
			{props.rows && props.rows.length == 0 && (
				<Box key={uuid()} className={classes.row}>
					<Box className={classes.cell}>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
					<Box
						className={clsx(
							classes.cell,
							classes.cellEnd
						)}
					>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
					<Box
						className={clsx(
							classes.cell,
							classes.cellEnd
						)}
					>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
				</Box>
			)}
		</Box>
	);
};
